import numeracyl0q1a from "./numeracy-l0q1a.json";
import numeracyl0q2a from "./numeracy-l0q2a.json";
import numeracyl0q3a from "./numeracy-l0q3a.json";
import numeracyl0q4a from "./numeracy-l0q4a.json";
import numeracyl0q5a from "./numeracy-l0q5a.json";
import numeracyl0q6a from "./numeracy-l0q6a.json";
import numeracyl0q7a from "./numeracy-l0q7a.json";
import numeracyl0q8a from "./numeracy-l0q8a.json";
import numeracyl0q9a from "./numeracy-l0q9a.json";
import numeracyl0q10a from "./numeracy-l0q10a.json";
import numeracyl0q11a from "./numeracy-l0q11a.json";
import numeracyl0q12a from "./numeracy-l0q12a.json";
import numeracyl0q13a from "./numeracy-l0q13a.json";
import numeracyl0q14a from "./numeracy-l0q14a.json";
import numeracyl0q15a from "./numeracy-l0q15a.json";
import numeracyl1q1a from "./numeracy-l1q1a.json";
import numeracyl1q1b from "./numeracy-l1q1b.json";

import numeracyl1q2a from "./numeracy-l1q2a.json";
import numeracyl1q2b from "./numeracy-l1q2b.json";
import numeracyl1q3a from "./numeracy-l1q3a.json";
import numeracyl1q3b from "./numeracy-l1q3b.json";

import numeracyl2q1a from "./numeracy-l2q1a.json";
import numeracyl2q1b from "./numeracy-l2q1b.json";
import numeracyl2q2a from "./numeracy-l2q2a.json";
import numeracyl2q2b from "./numeracy-l2q2b.json";
import numeracyl2q3a from "./numeracy-l2q3a.json";
import numeracyl2q3b from "./numeracy-l2q3b.json";
import numeracyl3q1a from "./numeracy-l3q1a.json";
import numeracyl3q1b from "./numeracy-l3q1b.json";
import numeracyl3q2a from "./numeracy-l3q2a.json";
import numeracyl3q2b from "./numeracy-l3q2b.json";
import numeracyl3q3a from "./numeracy-l3q3a.json";
import numeracyl3q3b from "./numeracy-l3q3b.json";
import numeracyl4q1a from "./numeracy-l4q1a.json";
import numeracyl4q2a from "./numeracy-l4q2a.json";
import numeracyl4q3a from "./numeracy-l4q3a.json";
import numeracyl4q4a from "./numeracy-l4q4a.json";
import numeracyl4q5a from './numeracy-l4q5a.json';

import readingl0q1a from "./reading-l0q1a.json";
import readingl0q2a from "./reading-l0q2a.json";
import readingl0q3a from "./reading-l0q3a.json";
import readingl0q4a from "./reading-l0q4a.json";
import readingl0q5a from "./reading-l0q5a.json";
import readingl0q6a from "./reading-l0q6a.json";
import readingl0q7a from "./reading-l0q7a.json";
import readingl0q8a from "./reading-l0q8a.json";
import readingl0q9a from "./reading-l0q9a.json";
import readingl0q10a from "./reading-l0q10a.json";
import readingl0q11a from "./reading-l0q11a.json";
import readingl0q12a from "./reading-l0q12a.json";
import readingl0q13a from "./reading-l0q13a.json";
import readingl0q14a from "./reading-l0q14a.json";
import readingl0q15a from "./reading-l0q15a.json";
import readingl1q1a from "./reading-l1q1a.json";
import readingl1q1b from "./reading-l1q1b.json";
import readingl1q2a from "./reading-l1q2a.json";
import readingl1q2b from "./reading-l1q2b.json";
import readingl1q3a from "./reading-l1q3a.json";
import readingl1q3b from "./reading-l1q3b.json";
import readingl2q1a from "./reading-l2q1a.json";
import readingl2q1b from "./reading-l2q1b.json";
import readingl2q2a from "./reading-l2q2a.json";
import readingl2q2b from "./reading-l2q2b.json";
import readingl2q3a from "./reading-l2q3a.json";
import readingl2q3b from "./reading-l2q3b.json";
import readingl3q1a from "./reading-l3q1a.json";
import readingl3q1b from "./reading-l3q1b.json";
import readingl3q2a from "./reading-l3q2a.json";
import readingl3q2b from "./reading-l3q2b.json";
import readingl3q3a from "./reading-l3q3a.json";
import readingl3q3b from "./reading-l3q3b.json";
import readingl4q1a from "./reading-l4q1a.json";
import readingl4q2a from "./reading-l4q2a.json";
import readingl4q3a from "./reading-l4q3a.json";

import writingl1q1a from "./writing-l1q1a.json";
import writingl1q1b from "./writing-l1q1b.json";
import writingl1q2a from "./writing-l1q2a.json";
import writingl1q2b from "./writing-l1q2b.json";
import writingl1q3a from "./writing-l1q3a.json";
import writingl1q3b from "./writing-l1q3b.json";
import writingl2q1a from "./writing-l2q1a.json";
import writingl2q1b from "./writing-l2q1b.json";
import writingl2q2a from "./writing-l2q2a.json";
import writingl2q2b from "./writing-l2q2b.json";
import writingl2q2c from "./writing-l2q2c.json";
import writingl2q2d from "./writing-l2q2d.json";
import writingl2q3a from "./writing-l2q3a.json";
import writingl2q3b from "./writing-l2q3b.json";
import writingl3q1a from "./writing-l3q1a.json";
import writingl3q1b from "./writing-l3q1b.json";
import writingl3q2a from "./writing-l3q2a.json";
import writingl3q2b from "./writing-l3q2b.json";
import writingl3q3a from "./writing-l3q3a.json";
import writingl3q3b from "./writing-l3q3b.json";
import writingl4q1a from "./writing-l4q1a.json";
import writingl4q2a from "./writing-l4q2a.json";
import writingl4q3a from "./writing-l4q3a.json";

import oralcommunicationl1q1a from "./oralcommunication-l1q1a.json";
import oralcommunicationl1q1b from "./oralcommunication-l1q1b.json";
import oralcommunicationl1q2a from "./oralcommunication-l1q2a.json";
import oralcommunicationl1q2b from "./oralcommunication-l1q2b.json";
import oralcommunicationl1q3a from "./oralcommunication-l1q3a.json";
import oralcommunicationl1q3b from "./oralcommunication-l1q3b.json";
import oralcommunicationl2q1a from "./oralcommunication-l2q1a.json";
import oralcommunicationl2q1b from "./oralcommunication-l2q1b.json";
import oralcommunicationl2q2a from "./oralcommunication-l2q2a.json";
import oralcommunicationl2q2b from "./oralcommunication-l2q2b.json";
import oralcommunicationl2q3a from "./oralcommunication-l2q3a.json";
import oralcommunicationl2q3b from "./oralcommunication-l2q3b.json";
import oralcommunicationl3q1a from "./oralcommunication-l3q1a.json";
import oralcommunicationl3q1b from "./oralcommunication-l3q1b.json";
import oralcommunicationl3q2a from "./oralcommunication-l3q2a.json";
import oralcommunicationl3q2b from "./oralcommunication-l3q2b.json";
import oralcommunicationl3q3a from "./oralcommunication-l3q3a.json";
import oralcommunicationl3q3b from "./oralcommunication-l3q3b.json";
import oralcommunicationl4q1a from "./oralcommunication-l4q1a.json";
import oralcommunicationl4q2a from "./oralcommunication-l4q2a.json";
import oralcommunicationl4q3a from "./oralcommunication-l4q3a.json";

import learningl1q1a from "./learning-l1q1a.json";
import learningl1q1b from "./learning-l1q1b.json";
import learningl1q2a from "./learning-l1q2a.json";
import learningl1q2b from "./learning-l1q2b.json";
import learningl1q3a from "./learning-l1q3a.json";
import learningl1q3b from "./learning-l1q3b.json";
import learningl2q1a from "./learning-l2q1a.json";
import learningl2q1b from "./learning-l2q1b.json";
import learningl2q2a from "./learning-l2q2a.json";
import learningl2q2b from "./learning-l2q2b.json";
import learningl2q3a from "./learning-l2q3a.json";
import learningl2q3b from "./learning-l2q3b.json";
import learningl3q1a from "./learning-l3q1a.json";
import learningl3q1b from "./learning-l3q1b.json";
import learningl3q2a from "./learning-l3q2a.json";
import learningl3q2b from "./learning-l3q2b.json";
import learningl3q3a from "./learning-l3q3a.json";
import learningl3q3b from "./learning-l3q3b.json";
import learningl4q1a from "./learning-l4q1a.json";
import learningl4q2a from "./learning-l4q2a.json";
import learningl4q3a from "./learning-l4q3a.json";

const questions = {
	"numeracy-l0q1a": numeracyl0q1a,
	"numeracy-l0q2a": numeracyl0q2a,
	"numeracy-l0q3a": numeracyl0q3a,
	"numeracy-l0q4a": numeracyl0q4a,
	"numeracy-l0q5a": numeracyl0q5a,
	"numeracy-l0q6a": numeracyl0q6a,
	"numeracy-l0q7a": numeracyl0q7a,
	"numeracy-l0q8a": numeracyl0q8a,
	"numeracy-l0q9a": numeracyl0q9a,
	"numeracy-l0q10a": numeracyl0q10a,
	"numeracy-l0q11a": numeracyl0q11a,
	"numeracy-l0q12a": numeracyl0q12a,
	"numeracy-l0q13a": numeracyl0q13a,
	"numeracy-l0q14a": numeracyl0q14a,
	"numeracy-l0q15a": numeracyl0q15a,
	"numeracy-l1q1a": numeracyl1q1a,
	"numeracy-l1q1b": numeracyl1q1b,

	"numeracy-l1q2a": numeracyl1q2a,
	"numeracy-l1q2b": numeracyl1q2b,
	"numeracy-l1q3a": numeracyl1q3a,
	"numeracy-l1q3b": numeracyl1q3b,

	"numeracy-l2q1a": numeracyl2q1a,
	"numeracy-l2q1b": numeracyl2q1b,
	"numeracy-l2q2a": numeracyl2q2a,
	"numeracy-l2q2b": numeracyl2q2b,
	"numeracy-l2q3a": numeracyl2q3a,
	"numeracy-l2q3b": numeracyl2q3b,
	"numeracy-l3q1a": numeracyl3q1a,
	"numeracy-l3q1b": numeracyl3q1b,
	"numeracy-l3q2a": numeracyl3q2a,
	"numeracy-l3q2b": numeracyl3q2b,
	"numeracy-l3q3a": numeracyl3q3a,
	"numeracy-l3q3b": numeracyl3q3b,
	"numeracy-l4q1a": numeracyl4q1a,
	"numeracy-l4q2a": numeracyl4q2a,
	"numeracy-l4q3a": numeracyl4q3a,
	"numeracy-l4q4a": numeracyl4q4a,
	"numeracy-l4q5a": numeracyl4q5a,

	"reading-l0q1a": readingl0q1a,
	"reading-l0q2a": readingl0q2a,
	"reading-l0q3a": readingl0q3a,
	"reading-l0q4a": readingl0q4a,
	"reading-l0q5a": readingl0q5a,
	"reading-l0q6a": readingl0q6a,
	"reading-l0q7a": readingl0q7a,
	"reading-l0q8a": readingl0q8a,
	"reading-l0q9a": readingl0q9a,
	"reading-l0q10a": readingl0q10a,
	"reading-l0q11a": readingl0q11a,
	"reading-l0q12a": readingl0q12a,
	"reading-l0q13a": readingl0q13a,
	"reading-l0q14a": readingl0q14a,
	"reading-l0q15a": readingl0q15a,
	"reading-l1q1a": readingl1q1a,
	"reading-l1q1b": readingl1q1b,
	"reading-l1q2a": readingl1q2a,
	"reading-l1q2b": readingl1q2b,
	"reading-l1q3a": readingl1q3a,
	"reading-l1q3b": readingl1q3b,
	"reading-l2q1a": readingl2q1a,
	"reading-l2q1b": readingl2q1b,
	"reading-l2q2a": readingl2q2a,
	"reading-l2q2b": readingl2q2b,
	"reading-l2q3a": readingl2q3a,
	"reading-l2q3b": readingl2q3b,
	"reading-l3q1a": readingl3q1a,
	"reading-l3q1b": readingl3q1b,
	"reading-l3q2a": readingl3q2a,
	"reading-l3q2b": readingl3q2b,
	"reading-l3q3a": readingl3q3a,
	"reading-l3q3b": readingl3q3b,
	"reading-l4q1a": readingl4q1a,
	"reading-l4q2a": readingl4q2a,
	"reading-l4q3a": readingl4q3a,
    
	"writing-l1q1a": writingl1q1a,
	"writing-l1q1b": writingl1q1b,
	"writing-l1q2a": writingl1q2a,
	"writing-l1q2b": writingl1q2b,
	"writing-l1q3a": writingl1q3a,
	"writing-l1q3b": writingl1q3b,
	"writing-l2q1a": writingl2q1a,
	"writing-l2q1b": writingl2q1b,
	"writing-l2q2a": writingl2q2a,
	"writing-l2q2b": writingl2q2b,
	"writing-l2q2c": writingl2q2c,
	"writing-l2q2d": writingl2q2d,
	"writing-l2q3a": writingl2q3a,
	"writing-l2q3b": writingl2q3b,
	"writing-l3q1a": writingl3q1a,
	"writing-l3q1b": writingl3q1b,
	"writing-l3q2a": writingl3q2a,
	"writing-l3q2b": writingl3q2b,
	"writing-l3q3a": writingl3q3a,
	"writing-l3q3b": writingl3q3b,
	"writing-l4q1a": writingl4q1a,
	"writing-l4q2a": writingl4q2a,
	"writing-l4q3a": writingl4q3a,

	"oralcommunication-l1q1a": oralcommunicationl1q1a,
	"oralcommunication-l1q1b": oralcommunicationl1q1b,
	"oralcommunication-l1q2a": oralcommunicationl1q2a,
	"oralcommunication-l1q2b": oralcommunicationl1q2b,
	"oralcommunication-l1q3a": oralcommunicationl1q3a,
	"oralcommunication-l1q3b": oralcommunicationl1q3b,
	"oralcommunication-l2q1a": oralcommunicationl2q1a,
	"oralcommunication-l2q1b": oralcommunicationl2q1b,
	"oralcommunication-l2q2a": oralcommunicationl2q2a,
	"oralcommunication-l2q2b": oralcommunicationl2q2b,
	"oralcommunication-l2q3a": oralcommunicationl2q3a,
	"oralcommunication-l2q3b": oralcommunicationl2q3b,
	"oralcommunication-l3q1a": oralcommunicationl3q1a,
	"oralcommunication-l3q1b": oralcommunicationl3q1b,
	"oralcommunication-l3q2a": oralcommunicationl3q2a,
	"oralcommunication-l3q2b": oralcommunicationl3q2b,
	"oralcommunication-l3q3a": oralcommunicationl3q3a,
	"oralcommunication-l3q3b": oralcommunicationl3q3b,
	"oralcommunication-l4q1a": oralcommunicationl4q1a,
	"oralcommunication-l4q2a": oralcommunicationl4q2a,
	"oralcommunication-l4q3a": oralcommunicationl4q3a,

	"learning-l1q1a": learningl1q1a,
	"learning-l1q1b": learningl1q1b,
	"learning-l1q2a": learningl1q2a,
	"learning-l1q2b": learningl1q2b,
	"learning-l1q3a": learningl1q3a,
	"learning-l1q3b": learningl1q3b,
	"learning-l2q1a": learningl2q1a,
	"learning-l2q1b": learningl2q1b,
	"learning-l2q2a": learningl2q2a,
	"learning-l2q2b": learningl2q2b,
	"learning-l2q3a": learningl2q3a,
	"learning-l2q3b": learningl2q3b,
	"learning-l3q1a": learningl3q1a,
	"learning-l3q1b": learningl3q1b,
	"learning-l3q2a": learningl3q2a,
	"learning-l3q2b": learningl3q2b,
	"learning-l3q3a": learningl3q3a,
	"learning-l3q3b": learningl3q3b,
	"learning-l4q1a": learningl4q1a,
	"learning-l4q2a": learningl4q2a,
	"learning-l4q3a": learningl4q3a,
};

export default questions;
